export default __webpack_public_path__ + "static/media/more.726c2378.svg";